enum ReactQueryKeyEnum {
  Organizations = 'organizations',
  Employees = 'employees',
}

export default ReactQueryKeyEnum;
